import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import Swal from 'sweetalert2';
import geografiaFunciones from '../function/geografia.Funciones';

const RegistrarEnteConformador = () => {
  const navigate = useNavigate(); // Hook para redireccionar
  const { id } = useParams();
  const edit = !!id;

  const [nitEnteconformador, setNitEnteconformador] = useState("");
  const [coddaneEnteconformador, setCoddaneEnteconformador] = useState("");
  const [nombreEnteconformador, setNombreEnteconformador] = useState("");
  const [direccionEnteconformador, setDireccionEnteconformador] = useState("");
  const [telefono1Enteconformador, setTelefono1Enteconformador] = useState("");
  const [telefono2Enteconformador, setTelefono2Enteconformador] = useState("");
  const [correoEnteconformador, setCorreoEnteconformador] = useState("");
  const [zonaEnteconformador, setZonaEnteconformador] = useState("");

  // Ubicación del Grupo
  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [ciudades, setCiudades] = useState([]);

  const [idPais, setIdPais] = useState('');
  const [idEstado, setIdEstado] = useState('');
  const [idCiudad, setIdCiudad] = useState('');

  const [paisSeleccionado, setPaisSeleccionado] = useState('');
  const [estadoSeleccionado, setEstadoSeleccionado] = useState('');
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState('');

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await axios.get(`/api/ente/listid/${id}`);
        if (!res.data.ok) return;

        const ente = res.data.enteConformador;

        // Asignaciones de datos normales
        setNitEnteconformador(ente.nitEnteconformador);
        setCoddaneEnteconformador(ente.coddaneEnteconformador);
        setNombreEnteconformador(ente.nombreEnteconformador);
        setDireccionEnteconformador(ente.direccionEnteconformador);
        setTelefono1Enteconformador(ente.telefono1Enteconformador);
        setTelefono2Enteconformador(ente.telefono2Enteconformador);
        setCorreoEnteconformador(ente.correoEnteconformador);
        setZonaEnteconformador(ente.zonaEnteconformador);

        // Carga de datos geográficos
        const paisesData = await geografiaFunciones.obtenerPaises();
        const estadosData = ente.idPais ? await geografiaFunciones.obtenerEstadosPorPais(ente.idPais) : [];
        const ciudadesData = ente.idEstado ? await geografiaFunciones.obtenerCiudadesPorEstado(ente.idEstado) : [];

        const estadosUnicos = Array.from(new Map(estadosData.map(e => [e.idEstado, e])).values());
        const ciudadesUnicas = Array.from(new Map(ciudadesData.map(c => [c.idCiudad, c])).values());

        setPaises(paisesData);
        setEstados(estadosUnicos);
        setCiudades(ciudadesUnicas);

        setIdPais(String(ente.idPais));
        setIdEstado(String(ente.idEstado));
        setIdCiudad(String(ente.idCiudad));

        setPaisSeleccionado(paisesData.find(p => String(p.idPais) === String(ente.idPais)) ? {
          value: String(ente.idPais),
          label: paisesData.find(p => String(p.idPais) === String(ente.idPais)).nombrePais
        } : null);

        setEstadoSeleccionado(estadosUnicos.find(e => String(e.idEstado) === String(ente.idEstado)) ? {
          value: String(ente.idEstado),
          label: estadosUnicos.find(e => String(e.idEstado) === String(ente.idEstado)).nombreEstado
        } : null);

        setCiudadSeleccionada(ciudadesUnicas.find(c => String(c.idCiudad) === String(ente.idCiudad)) ? {
          value: String(ente.idCiudad),
          label: ciudadesUnicas.find(c => String(c.idCiudad) === String(ente.idCiudad)).nombreCiudad
        } : null);

      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'No se pudo cargar el ente conformador', 'error');
      }
    };

    if (id) getData();
  }, [id]);



  const cleanData = () => {
    setNitEnteconformador('');
    setCoddaneEnteconformador('');
    setNombreEnteconformador('');
    setDireccionEnteconformador('');
    setTelefono1Enteconformador('');
    setTelefono2Enteconformador('');
    setCorreoEnteconformador('');
    setZonaEnteconformador('');

    // Limpiar ubicación
    setIdPais('');
    setIdEstado('');
    setIdCiudad('');
    setPaisSeleccionado('');
    setEstadoSeleccionado('');
    setCiudadSeleccionada('');
    setPaises([]);
    setEstados([]);
    setCiudades([]);

    navigate(-1)
  };

  const saveEnteConformador = async () => {
    try {
      const newEnteConformador = {
        nitEnteconformador,
        coddaneEnteconformador,
        nombreEnteconformador,
        direccionEnteconformador,
        telefono1Enteconformador,
        telefono2Enteconformador,
        correoEnteconformador,
        zonaEnteconformador,
        idPais,
        idEstado,
        idCiudad,
        paisSeleccionado,
        estadoSeleccionado,
        ciudadSeleccionada
      };

      await axios.post('/api/ente/add', newEnteConformador);
      cleanData();

      // SweetAlert2 para mostrar éxito
      Swal.fire({
        icon: 'success',
        title: 'El Ente Conformador ha sido registrado con éxito',
        showConfirmButton: false,
        timer: 1500
      }).then(() => {
        navigate('/enteconformador/listar'); // Redirecciona después de la alerta
      });


    } catch (error) {
      if (error.response?.data?.message) {
        return alert(error.response.data.message);
      }
      console.error('Error en saveEnteConformador:', error.message);
    }
  };


  const updateEnteConformador = async () => {
    try {
      const enteConformadorUpdate = {
        nitEnteconformador,
        coddaneEnteconformador,
        nombreEnteconformador,
        direccionEnteconformador,
        telefono1Enteconformador,
        telefono2Enteconformador,
        correoEnteconformador,
        zonaEnteconformador,
        idPais,
        idEstado,
        idCiudad
      };

      await axios.put(`/api/ente/update/${id}`, enteConformadorUpdate);

      Swal.fire({
        icon: 'success',
        title: 'EnteConformador actualizado exitosamente',
        showConfirmButton: false,
        timer: 1500
      }).then(() => {
        navigate('/enteconformador/listar');
      });

    } catch (error) {
      console.error('Error al actualizar el EnteConformador:', error);
      Swal.fire('Error', 'No se pudo actualizar el EnteConformador', 'error');
    }
  };





  const actions = async (e) => {
    e.preventDefault();
    edit ? await updateEnteConformador() : await saveEnteConformador();
  };



  useEffect(() => {
    const cargarPaises = async () => {
      const paisesData = await geografiaFunciones.obtenerPaises();
      setPaises(paisesData);
    };
    cargarPaises();
  }, []);

  const handlePaisChange = async (selectedOption) => {
    setPaisSeleccionado(selectedOption);
    setIdPais(selectedOption?.value || '');

    const estadosData = await geografiaFunciones.obtenerEstadosPorPais(selectedOption.value);
    setEstados(estadosData);
    setEstadoSeleccionado(null);
    setCiudadSeleccionada(null);
  };

  const handleEstadoChange = async (selectedOption) => {
    setEstadoSeleccionado(selectedOption);
    setIdEstado(selectedOption?.value || '');

    const ciudadesData = await geografiaFunciones.obtenerCiudadesPorEstado(selectedOption.value);
    setCiudades(ciudadesData);
    setCiudadSeleccionada(null);
  };

  const handleCiudadChange = (selectedOption) => {
    setCiudadSeleccionada(selectedOption);
    setIdCiudad(selectedOption?.value || '');
  };


  const paisOptions = Array.from(
    new Map(paises.map(p => [p.idPais, { value: p.idPais, label: p.nombrePais }])).values()
  );

  const estadoOptions = Array.from(
    new Map(estados.map(e => [e.idEstado, { value: e.idEstado, label: e.nombreEstado }])).values()
  );

  const ciudadOptions = Array.from(
    new Map(ciudades.map(c => [c.idCiudad, { value: c.idCiudad, label: c.nombreCiudad }])).values()
  );




  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
      < div className='container-fluid mt-3' >
        <h1>Registrar Ente Conformador</h1>
      </div>

      <div className="mb-5">
        <form onSubmit={actions}>
          <div className="container">
            <div className="row g-3 align-items-end justify-content-center">

              {/* Campo de DANE */}
              <div className="col-md-3">
                <label htmlFor="dane" className="form-label">DANE</label>
                <input
                  type="text"
                  className="form-control"
                  id="dane"
                  placeholder="Ingrese el DANE"
                  value={coddaneEnteconformador}
                  onChange={(e) => setCoddaneEnteconformador(e.target.value)}
                  required
                />
              </div>

              {/* Campo de NIT */}
              <div className="col-md-3">
                <label htmlFor="nit" className="form-label">NIT</label>
                <input
                  type="text"
                  className="form-control"
                  id="nit"
                  placeholder="Ingrese el NIT"
                  value={nitEnteconformador}
                  onChange={(e) => setNitEnteconformador(e.target.value)}
                  required
                />
              </div>


              {/* Campo de Nombre de la Empresa */}
              <div className="col-md-6">
                <label htmlFor="nombreEmpresa" className="form-label">Nombre de la Empresa</label>
                <input
                  type="text"
                  className="form-control"
                  id="nombreEmpresa"
                  placeholder="Ingrese el nombre de la empresa"
                  value={nombreEnteconformador}
                  onChange={(e) => setNombreEnteconformador(e.target.value)}
                  required
                />
              </div>


              {/* Campo de Dirección */}
              <div className="col-md-6">
                <label htmlFor="direccion" className="form-label">Dirección</label>
                <input
                  type="text"
                  className="form-control"
                  id="direccion"
                  placeholder="Ingrese la dirección"
                  value={direccionEnteconformador}
                  onChange={(e) => setDireccionEnteconformador(e.target.value)}
                  required
                />
              </div>

              {/* Campo de Telefono1 */}
              <div className="col-md-3">
                <label htmlFor="telefono1" className="form-label">Teléfono 1</label>
                <input
                  type="text"
                  className="form-control"
                  id="telefono1"
                  placeholder="Ingrese el Teléfono 1"
                  value={telefono1Enteconformador}
                  onChange={(e) => setTelefono1Enteconformador(e.target.value)}
                  required
                />
              </div>

              {/* Campo de Telefono2 */}
              <div className="col-md-3">
                <label htmlFor="telefono2" className="form-label">Teléfono 2</label>
                <input
                  type="text"
                  className="form-control"
                  id="telefono2"
                  placeholder="Ingrese el Teléfono 2"
                  value={telefono2Enteconformador}
                  onChange={(e) => setTelefono2Enteconformador(e.target.value)}
                  required
                />
              </div>


              <div className="col-md-4">
                <label htmlFor="paisgrupo" className="form-label">País</label>
                <Select
                  id="paisgrupo"
                  options={paisOptions}
                  value={paisSeleccionado}
                  onChange={handlePaisChange}
                  placeholder="Seleccione un país"
                  isClearable
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="estado" className="form-label">Estado / Departamento</label>
                <Select
                  id="estado"
                  options={estadoOptions}
                  value={estadoSeleccionado}
                  onChange={handleEstadoChange}
                  placeholder="Seleccione un estado"
                  isDisabled={!paisSeleccionado}
                  isClearable
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="ciudad" className="form-label">Ciudad</label>
                <Select
                  id="ciudad"
                  options={ciudadOptions}
                  value={ciudadSeleccionada}
                  onChange={handleCiudadChange}
                  placeholder="Seleccione una ciudad"
                  isDisabled={!estadoSeleccionado}
                  isClearable
                />
              </div>



              <div className="col-md-8">
                <label htmlFor="email" className="form-label">Correo Electrónico</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Ingrese el correo electrónico"
                  value={correoEnteconformador}
                  onChange={(e) => setCorreoEnteconformador(e.target.value)}

                />
              </div>

              {/* Campo de Zona del Ente Conformador */}
              <div className="col-md-4">
                <label htmlFor="zonaEnteconformador" className="form-label">Zona del Ente Conformador</label>
                <select
                  id="zonaEnteconformador"
                  className="form-select"
                  value={zonaEnteconformador}
                  onChange={(e) => setZonaEnteconformador(e.target.value)}
                  required
                >
                  <option value="" disabled selected>Seleccione la zona</option>
                  <option value="urbano">Urbano</option>
                  <option value="rural">Rural</option>
                </select>
              </div>
            </div>

            {/* Botón de envío */}
            <div className="col-12 mt-4 mb-5">
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <button type="submit" className="btn btn-success w-100">
                    {edit ? 'Actualizar' : 'Enviar'}
                  </button>
                </div>
                <div className="col-12 col-md-6">
                  <button type="button" className="btn btn-danger w-100" onClick={cleanData}>
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegistrarEnteConformador;
